<template>
    <div class="materialList__iconHolder">
        <input type="checkbox" :id="id" class="materialList__iconControl">
        <label :for="id" class="materialList__icon">i</label>
        <div class="materialList__iconExplain">
            <p><strong v-html="$options.filters.supCharacter(hint.headline)"/> {{hint.description}}</p>
            <p><a v-bind:href="hint.link" target="_blank" class="link">Zjistit více</a></p>
            <p class="text--right">
                <label :for="id" class="materialList__closeHelp text--red">&times; Zavřít</label>
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'CalculationHint',
        props: {
            hint: Object
        },
        data() {
            return {
                id: Math.random()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/hint/Hint.vue